export default __webpack_public_path__ + "locales/en/Article.json?hash=9ac2f8857dab1a7c709ebecd1bd32e8c";